// extracted by mini-css-extract-plugin
export default {"headerDiv":"OurWorkHeader_headerDiv__wp1EC","headerContent":"OurWorkHeader_headerContent__ks+B1","title":"OurWorkHeader_title__zJvgc","headerText":"OurWorkHeader_headerText__fmlDw"};